// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\ActionTrackingSearchResponse

import { hydrateActionTracking, type ActionTracking, type ActionTrackingApiResponse } from './actionTracking.gen';

export type ActionTrackingSearchApiResponse = {
	items: ActionTrackingApiResponse[];
};

export type ActionTrackingSearch = {
	items: ActionTracking[];
};

export function hydrateActionTrackingSearch(data: ActionTrackingSearchApiResponse): ActionTrackingSearch {
	return {
		...data,
		items: data.items.map(hydrateActionTracking),
	};
}